import { Button, Col, Form, Row } from "antd";
import TextArea from "antd/es/input/TextArea";
import React, { useState } from "react";
import CommentBox from "../../../../../inboxItemPages/components/commentBox";
import TaskCheckedList from "../../../../../inboxItemPages/components/taskCheckedList";
import { collection, doc, getDoc, updateDoc } from "firebase/firestore";
import { db } from "../../../../../../../../firebase";

function ReviewPropertyInspection({ itemId, listId, checkedItems }) {
  const isItemChecked = checkedItems[itemId.toString()]; // Convert itemId to string because keys in checkedItems are strings.

  const [isDisabled, setIsDisabled] = useState(isItemChecked);
  const tasksRef = collection(db, "tasks");
  const itemListRef = doc(tasksRef, "itemList");
  const assignedCollectionRef = collection(itemListRef, "Assigned");

  function handleUndefinedValues(obj) {
    const newObj = {};
    for (let key in obj) {
      newObj[key] = obj[key] === undefined ? "" : obj[key];
    }
    return newObj;
  }
  const onFinish = async (values) => {
    console.log("Success:", values);
    values = handleUndefinedValues(values);
    const targetDocRef = doc(assignedCollectionRef, listId);

    try {
      const docSnapshot = await getDoc(targetDocRef);

      if (docSnapshot.exists()) {
        const data = docSnapshot.data();
        if (data && data.workItemList) {
          const updatedWorkItemList = data.workItemList.map((item) => {
            return {
              ...item,
              status:
                item.id == itemId && item.status == "incompleted"
                  ? "completed"
                  : item.status,
              details: item.id == itemId && values,
            };
          });

          await updateDoc(targetDocRef, {
            workItemList: updatedWorkItemList,
          });

          console.log("Document successfully updated!");
          setIsDisabled(true);
        } else {
          console.log("workItemList not found in the document!");
        }
      } else {
        console.log("Document does not exist!");
      }
    } catch (error) {
      console.error("Error updating document:", error);
    }
  };
  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };
  return (
    <div className="item-page">
      <Form
        className="item-page-container"
        layout="vertical"
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
      >
        <Row gutter={[0, 24]}>
          <Col span={24}>
            <p className="pink-info-text">
              Review the inspection in the link below. Look for items of
              concern. they would be items such as
            </p>
          </Col>
          <Col span={24}>
            <p>-damage or disrepair of the home in the pictures.</p>
          </Col>
          <Col span={24}>
            <p>-lack of sufficient pictures</p>
          </Col>
          <Col span={24}>
            <p>-the same picture over and over</p>
          </Col>
          <Col span={24}>
            <p>
              -items that make you feel the home should have an in person
              inspection.
            </p>
          </Col>
          <Col span={24}>
            <Form.Item label="Link to inspection" name="linkToInspection">
              <TextArea placeholder="Type answer here..." rows={2} />
            </Form.Item>
          </Col>
          <Col span={24}>
            <p>
              If an in person inspection is warranted click on the link below
              and create a request and assign it to Gina with a due date.
            </p>
          </Col>
          <Col span={24}>
            <p className="onclick-text">
              https://app.process.st/workflows/In-person-inspection-hp47iEWZxV63asUhQQpCsw/run-link
            </p>
          </Col>
          <Col span={24}>
            <p>
              Here is the text message that the tenant was sent with the
              inspection link for your reference{" "}
            </p>
          </Col>
          <Col span={24}>
            <h3>
              We are asking all tenant to do a self inspection during their
              lease. Please use the link below to complete. Be aware that this
              is also a requirement for lease renewals and move outs so please
              get it done asap. If you have any questions just reply back{" "}
              <strong className="onclick-text">
                https://form.jotform.com/222006850890150
              </strong>{" "}
            </h3>
          </Col>
          <Col span={24}>
            <Row justify="end" gutter={[8, 0]}>
              <Col>
                <Button type="primary" htmlType="submit" disabled={isDisabled}>
                  Complete
                </Button>
              </Col>
            </Row>
          </Col>
        </Row>
        <Row>
          <Col span={24}>
            <CommentBox />
          </Col>
          <Col span={24}>
            <TaskCheckedList />
          </Col>
        </Row>
      </Form>
    </div>
  );
}

export default ReviewPropertyInspection;
